import { BannerMessageActionTypes } from "../../../../enums";

const { SET_BANNER_MESSAGES_SEEN } = BannerMessageActionTypes;

export const setBannerMessagesSeen = (ids: Array<String>) => {
  return {
    type: SET_BANNER_MESSAGES_SEEN,
    ids: JSON.stringify(ids)
  }
}